import { useState, useEffect } from 'react';
import { UsersApi } from '@apply/api';
import { applicationInsights } from '../../ApplicationInsights';
import { BrokerActionType } from '../common/Constants';
import { useSelector } from 'react-redux';
import { formatDate } from '../../common/SharedFunctions';
import { BfiDataGrid, Column } from '../../common/SharedComponents';
import { GridSettingType } from '@apply/constants';
import { executeBrokerAction, onBrokerActionsCellRender } from '../common/Functions';

const BrokerUsersTable = ({ gridStore, filter }) => {
    const searchState = useSelector((state) => state.searchState);
    const [dataStore, set_dataStore] = useState(gridStore?.store);

    const usersApi = new UsersApi.UsersApi(applicationInsights);

    const dataFunction = (criteria) => {
        if (!criteria) {
            return;
        }
        criteria.filter = filter;
        return usersApi.getBrokerUsers(criteria);
    };

    useEffect(() => {
        if (gridStore) {
            gridStore.setOnLoad('id', dataFunction, searchState?.searchText?.brokerUser);
            set_dataStore(gridStore.store);
        }
    }, [gridStore]);

    const dateCellRender = (date) => {
        if (date) {
            return <>{formatDate(date)}</>;
        }

        return;
    };

    const onCellDblClick = (e) => {
        if (e.rowType !== 'data' || e.column.type === 'detailExpand' || e.column.type === 'actions' || e.data.brokerId === null) {
            return;
        }
        var model = {
            actionId: BrokerActionType.ViewEditBroker,
            brokerId: e.data.brokerId,
        };
        executeBrokerAction(model, false);
    };

    return (
        <BfiDataGrid
            gridType={GridSettingType.BrokerUsersTable}
            dataStore={dataStore}
            applicationInsights={applicationInsights}
            onCellDblClick={onCellDblClick}
        >
            <Column
                dataField='firstName'
                caption='First'
                dataType='string'
                width={120}
            />
            <Column
                dataField='lastName'
                caption='Last'
                dataType='string'
                width={120}
            />
            <Column
                dataField='email'
                caption='Email'
                dataType='string'
                width={220}
            />
            <Column
                dataField='created'
                caption='Created'
                cellRender={(e) => dateCellRender(e.data.created)}
                width={120}
            />
            <Column
                dataField='lastActive'
                caption='Last Active'
                cellRender={(e) => dateCellRender(e.data.lastActive)}
                width={120}
            />
            <Column
                dataField='lastLoginIPAddress'
                caption='Last Login IP'
                dataType='string'
                width={100}
            />
            <Column
                dataField='lastPasswordResetRequested'
                caption='Last Pwd Requested'
                cellRender={(e) => dateCellRender(e.data.lastPasswordResetRequested)}
                width={140}
            />
            <Column
                dataField='lastPasswordResetSent'
                caption='Last Pwd Reset Sent'
                cellRender={(e) => dateCellRender(e.data.lastPasswordResetSent)}
                width={140}
            />
            <Column
                dataField='lastFailedLoginAttempt'
                caption='Last Failed Login'
                cellRender={(e) => dateCellRender(e.data.lastFailedLoginAttempt)}
                width={120}
            />
            <Column
                dataField='iccaType'
                caption='Icca Type'
                dataType='string'
                width={200}
            />
            <Column
                dataField='amountClosed'
                caption='Amount Closed'
                dataType='number'
                format='currency'
                width={200}
                alignment={'left'}
            />
            <Column
                alignment='center'
                cellRender={(e) => onBrokerActionsCellRender(e, 'BrokersGrid')}
                width={50}
                allowSorting={false}
                allowResizing={false}
                type='actions'
                fixed={true}
                fixedPosition={'right'}
            />
        </BfiDataGrid>
    );
};

export default BrokerUsersTable;
